import React, { useState, useEffect } from 'react';
import DetailsForm from "./components/DetailsForm";
import Avatar from "./components/CompanyAvatar";
import { Col, Input } from "antd";
import { useLocation } from "react-router-dom";
import MediaQuery from "react-responsive";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons"
import { BsArrowLeft } from "react-icons/bs"
import './CompanyDetails.css';
import history from '../../../routes/history';
// import {
//   getCompanyDetailsSuggestions,
// } from '../../../../redux/actions';
import {
  getCompanyDetailsSuggestions,
} from '../../../redux/actions';
import { useDispatch, useSelector } from "react-redux";
import {
  getPersonalDetailsLocation,
  fetchUserProfile,
  getCompanyProfileDetails,
} from "../../../redux/actions";

const CompanyDetails = () => {
  
  const dispatch = useDispatch();
  const [imageKey, setImageKey] = useState(null);
  const [deleteCheck,setDeleteCheck] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const imageURL = JSON.parse(localStorage.getItem("profilePicture"));

  useEffect(() => {
    dispatch(getCompanyDetailsSuggestions());
  }, [])
  const location = useLocation();
  
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const token = useSelector((state) => state.authReducer.user.authToken);
  const finishProf = useSelector((state) => state.profileReducer.finisProf);
  
  const success = useSelector(
    (state) => state.getCompanyDetailsReducer.success
  );

  useEffect(() => {
    setImageKey(imageURL)
    dispatch(getPersonalDetailsLocation(""));
  }, []);

  useEffect(() => { 
    dispatch(getCompanyProfileDetails());
    dispatch(fetchUserProfile(token));

 
    // dispatch(fetchUserProfile(token));

  },[])
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    // console.log('Company Details Location.state:',location.state);
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={'main-container-div'}>
      <Col className="formStyle" lg={13} md={15} sm={18} xs={24}>
        <div>
          {windowDimensions.width < 769 && finishProf ?
            <div>
              <BsArrowLeft className="back-arrow"
                onClick={() => history.goBack()}
              />
            </div> : null
          }
          <div className='company-details-text'>Add your company details</div>
          <Avatar state={location.state} companyProfile={true} setImageLoading={setImageLoading} setDeleteCheck={setDeleteCheck}  setImageKey={setImageKey}/>
          <DetailsForm method={"get"} imageLoading={imageLoading} profileImageDeleteCheck={deleteCheck} state={location.state} profileImageKey={imageKey} />
        </div>
      </Col>
    </div>
  );
};
export default CompanyDetails;
